import { render, staticRenderFns } from "./ChartCollection.vue?vue&type=template&id=6f0f592f&scoped=true&"
import script from "./ChartCollection.vue?vue&type=script&lang=js&"
export * from "./ChartCollection.vue?vue&type=script&lang=js&"
import style0 from "./ChartCollection.vue?vue&type=style&index=0&id=6f0f592f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0f592f",
  null
  
)

export default component.exports